import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import AdminPanel from './components/AdminPanel';
import LogsViewer from './components/LogsViewer';
import ActionsDev from './components/ActionsDev';
import ScriptPermissions from './components/ScriptPermissions';
import VIPManager from './components/VIPManager';
import { NotificationProvider } from './components/Notification';
import { API_URL } from './config';
import './App.css';

function App() {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    // Vérifier si on revient du callback Discord avec un token
    const params = new URLSearchParams(window.location.search);
    const tokenFromUrl = params.get('token');
    const isNewUser = params.get('new') === 'true';
    
    console.log('App useEffect - tokenFromUrl:', tokenFromUrl ? 'présent' : 'absent');
    
    if (tokenFromUrl) {
      console.log('Token reçu de Discord, stockage dans localStorage');
      localStorage.setItem('token', tokenFromUrl);
      // Nettoyer l'URL
      window.history.replaceState({}, document.title, '/');
      
      // Récupérer les infos utilisateur
      fetch(`${API_URL}/api/auth/me`, {
        headers: {
          'Authorization': `Bearer ${tokenFromUrl}`
        }
      })
        .then(res => {
          console.log('Réponse /api/auth/me:', res.status);
          return res.json();
        })
        .then(data => {
          console.log('Données utilisateur après Discord:', data);
          if (data.user) {
            console.log('Utilisateur connecté:', data.user);
            setUser(data.user);
          } else {
            console.log('Pas de données utilisateur, suppression du token');
            localStorage.removeItem('token');
          }
        })
        .catch((err) => {
          console.error('Erreur /api/auth/me:', err);
          localStorage.removeItem('token');
        })
        .finally(() => {
          console.log('setLoading(false)');
          setLoading(false);
        });
      return;
    }
    
    // Vérifier si l'utilisateur est déjà connecté
    const token = localStorage.getItem('token');
    console.log('App useEffect - token localStorage:', token ? 'présent' : 'absent');
    if (token) {
      console.log('Token trouvé, appel /api/auth/me');
      fetch(`${API_URL}/api/auth/me`, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
        .then(res => {
          console.log('Réponse /api/auth/me:', res.status);
          return res.json();
        })
        .then(data => {
          console.log('Données utilisateur:', data);
          if (data.user) {
            console.log('Utilisateur défini:', data.user);
            setUser(data.user);
          } else {
            console.log('Pas de données utilisateur, suppression du token');
            localStorage.removeItem('token');
          }
        })
        .catch((err) => {
          console.error('Erreur /api/auth/me:', err);
          localStorage.removeItem('token');
        })
        .finally(() => {
          console.log('setLoading(false)');
          setLoading(false);
        });
    } else {
      console.log('Pas de token, setLoading(false)');
      setLoading(false);
    }
  }, []);

  const handleLogin = (userData) => {
    setUser(userData);
  };

  const handleLogout = () => {
    localStorage.removeItem('token');
    setUser(null);
  };

  if (loading) {
    return (
      <div className="loading">
        <div className="spinner"></div>
        <p>Chargement...</p>
      </div>
    );
  }

  return (
    <NotificationProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route 
              path="/login" 
              element={user ? <Navigate to="/" /> : <Login onLogin={handleLogin} />} 
            />
            <Route 
              path="/" 
              element={user ? <Dashboard user={user} onLogout={handleLogout} /> : <Navigate to="/login" />} 
            >
              <Route index element={<LogsViewer user={user} />} />
              <Route 
                path="admin" 
                element={user?.role === 'admin' ? <AdminPanel /> : <Navigate to="/" />} 
              />
              <Route 
                path="actions-dev" 
                element={user?.role === 'admin' ? <ActionsDev /> : <Navigate to="/" />} 
              />
              <Route 
                path="script-permissions" 
                element={user?.role === 'admin' ? <ScriptPermissions /> : <Navigate to="/" />} 
              />
              <Route 
                path="vip" 
                element={user?.role === 'admin' ? <VIPManager /> : <Navigate to="/" />} 
              />
            </Route>
          </Routes>
        </div>
      </Router>
    </NotificationProvider>
  );
}

export default App;
